import { v4 as uuidv4 } from 'uuid';

export const genUUID = () => {
	return uuidv4().replace(/-/g, "");
}
